export default "__VITE_ASSET__C2JH26DR__"